<template>
    <v-card width="240" light elevation="24" :disabled="!isConsole">
        <v-card-title class="font-weight-bold">수수료정책</v-card-title>
        <v-card-text>
            <v-text-field v-model="shop.commission.default" type="number" label="업체수수료" placeholder=" " append-icon="mdi-percent" />
            <v-text-field v-model="shop.commission.creditCard" type="number" label="결제수수료(카드)" placeholder=" " append-icon="mdi-percent" />
            <v-text-field v-model="shop.commission.bankTransfer" type="number" label="결제수수료(계좌이체)" placeholder=" " append-icon="mdi-percent" />
            <v-text-field v-model="shop.commission.virtualAccount" type="number" label="결제수수료(무통장)" placeholder=" " append-icon="mdi-percent" />
            <v-text-field v-model="shop.commission.mobilePayment" type="number" label="결제수수료(휴대폰)" placeholder=" " append-icon="mdi-percent" />
        </v-card-text>

        <v-card-actions v-if="isConsole">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="save">저장</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: Boolean, default: false },
    },
    computed:{
        isConsole() {
            return this.$store.state.scope.includes("console");
        }
    },
    data() {
        return {
            shop: {
                commission: {
                    default: null,
                    creditCard: null,
                    bankTransfer: null,
                    virtualAccount: null,
                    mobilePayment: null,
                },
            },
        };
    },
    methods: {
        async search() {
            try {
                const {
                    setting: { shop },
                } = await api.console.setting.getSetting();
                this.shop = shop;
            } catch (error) {
                this.handleError(error);
            }
        },
        async save() {
            try {
                const shop = this.shop;
                await api.console.setting.putSetting({ shop });
                alert("수수료정책이 설정되었습니다.");
                await this.search();
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    async mounted() {
        await this.search();
    },
    watch: {
        value() {
            if (this.value) this.search();
        },
    },
};
</script>
